<div class="home-container">
  <axis-hero-banner
    title="Delicious Takeaway, Fast & Fresh Online Ordering"
    subtitle="Order from our website for a 10% discount"
    backgroundImage="/images/hero.png"
    [buttonText]="'Order Now'"
    [buttonLink]="'/menu'"
    [secondaryButtonText]="'See Our Menu'"
    [secondaryButtonLink]="'/menu'"
  >
  </axis-hero-banner>
</div>

<section class="featured-section">
  <axis-featured-v2
    [title]="'Our Featured Items'"
    [subtitle]="'Order your favourite dishes online'"
    [alignText]="'left'"
    [services]="featuredMenus"
  ></axis-featured-v2>
</section>

<!-- How It Works Section -->
<axis-how-it-works
  [title]="'How It Works'"
  [steps]="howItWorks"
></axis-how-it-works>

<div class="offers-section">
  <axis-featured-services
    [services]="featuredMenus2"
    [servicesPageLink]="'/menu'"
    alignText="left"
    [title]="'Exclusive Offers'"
    [subtitle]="
      'Discover special deals and discounts available only on our website'
    "
  ></axis-featured-services>
</div>
<!-- Google Business Reviews Section -->
<axis-g-reviews-section
  [title]="'What Our Customers Say'"
  [reviews]="googleReviews"
  [subtitle]="'We are proud to have a 4.9-star rating on Google'"
  [alignText]="'left'"
></axis-g-reviews-section>
